import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDeleteInsuredPerson } from 'hooks/useDeleteInsuredPerson';

export const DeletePatientDialog = ({
  userId,
  redirect = false,
}: {
  userId: string;
  redirect?: boolean;
}): React.ReactElement => {
  const { mutate: deletePatient, isPending } = useDeleteInsuredPerson();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  const handleDeletePatient = (): void => {
    deletePatient({ userId, redirect });
  };

  return (
    <Dialog
      className="w-3xl"
      title={t('RemoveInsuredPersonDialog.heading')}
      secondaryAction={{
        label: (
          <>
            <X className="size-4" />
            {t('RemoveInsuredPersonDialog.cancel')}
          </>
        ),
        variant: 'destructive_terciary',
        size: 'lg',
        icon: 'leading',
      }}
      primaryAction={{
        label: t('RemoveInsuredPersonDialog.cta', { ns: LOCIZE_NS.INSURANCE }),
        action: handleDeletePatient,
        variant: 'destructive',
        size: 'lg',
        isLoading: isPending,
      }}
      open
      enableOutsideClick={false}
    >
      <p className="text-sm text-gray-600">
        {t('RemoveInsuredPersonDialog.body')}
        <br />
        {t('RemoveInsuredPersonDialog.irreversible')}
      </p>
    </Dialog>
  );
};
